import { Button } from "@chakra-ui/react";
import { Modal } from "react-bootstrap";

function DeleteModal({title,ViewDelete,handleDeleteClose,handleDelete}) {
  return (
    <div>
        <div className="model-box-view" id="deleteaccount">
        <Modal
          show={ViewDelete}
          onHide={handleDeleteClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title className="usertitle">{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure to delete?</p>
          </Modal.Body>
          <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
            <Button className="cancel" onClick={handleDeleteClose}>
              Cancel
            </Button>
            <Button className="btn_bg_color" onClick={handleDelete}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  )
}

export default DeleteModal
